import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  display: flex;
  height: 100%;
  background-color: white;
  padding: 85px 20px 20px 20px;
  justify-content: center;
`;

export const EditorBodyContainer = styled.div`
  width: 100%;
  height: calc(${window.innerHeight}px - 100px);
  overflow-y: auto;
  background-color: white;
`;
